export default {
  v3SubmitErrBtnViewOrder: 'عرض الطلب',
  v3SubmitErrBtnBackHome: 'الرئيسية',
  v3SubmitErrBtnRetry: 'إعادة المحاولة',
  v3SubmitErrBtnRelogin: 'إعادة تسجيل الدخول',
  v3SubmitErrBtnSwitchPay: 'تغيير طريقة الدفع',
  v3SubmitErrBtnReorder: 'إعادة الطلب',
  v3SubmitErrBtnSwitchServer: 'تغيير الخادم',
  v3SubmitErrBtnViewOrderStatus: 'حالة الطلب',
  v3SubmitErrBtnBackStore: 'العودة إلى المتجر',
  v3SubmitErrBtnGoUpdate: 'تحديث',
  v3SubmitErrBtnResubscribe: 'إعادة الاشتراك',
  v3SubmitErrTipUpdateApp: 'قم بالتحديث عبر متجر التطبيقات',
  v3SubmitErrTipRelogin: 'الرجاء تسجيل الدخول مجدداً',

  v3SubmitErrMsg120009: 'تمت معالجة الطلب – تحقق من حقيبتك في اللعبة.',
  v3SubmitErrMsg120003: 'خطأ في معلومات المنتج – اختر مجدداً.',
  v3SubmitErrMsg120016: 'طلبات كثيرة جداً – انتظر بضع ثوان وحاول مجدداً.',
  v3SubmitErrMsg120025: 'معاملات الطلب غير طبيعية – سجل الدخول مجدداً وحاول.',
  v3SubmitErrMsg121012: 'قناة الدفع غير متاحة مؤقتاً – جرب طريقة أخرى.',
  v3SubmitErrMsg120012: 'الشبكة غير مستقرة – تحقق من اتصالك وحاول مجدداً.',
  v3SubmitErrMsg120002: 'لم يتم العثور على شخصية – أنشئ شخصية أولاً.',
  v3SubmitErrMsg121019: 'خطأ في معلومات الطلب – قدم طلباً جديداً.',
  v3SubmitErrMsg120024: 'تم استلام هدية التسجيل المسبق – لا حاجة للتكرار.',
  v3SubmitErrMsg120000: 'انتهت صلاحية الجلسة – سجل الدخول مجدداً.',
  v3SubmitErrMsg120014: 'رقم الطلب غير صالح – قدم طلباً جديداً.',
  v3SubmitErrMsg121001: 'فشلت عملية الشحن في اللعبة – حاول لاحقاً أو اتصل بالدعم.',
  v3SubmitErrMsg120015: 'مبلغ الدفع غير طبيعي – اختر المنتج مجدداً.',
  v3SubmitErrMsg120001: 'الخادم غير متطابق – انتقل إلى الخادم الصحيح.',
  v3SubmitErrMsg120020: 'قناة الدفع أرجعت خطأ – جرب طريقة أخرى.',
  v3SubmitErrMsg120010: 'وظيفة الشحن مغلقة مؤقتاً – حاول لاحقاً.',
  v3SubmitErrMsg120006: 'فشل التحقق من المبلغ – اختر مجدداً.',
  v3SubmitErrMsg121010: 'طلب الشحن في بيئة الاختبار غير صالح – استخدم النسخة الرسمية.',
  v3SubmitErrMsg120017: 'رقم الطلب مكرر – تحقق مما إذا كان قد تم دفعه.',
  v3SubmitErrMsg120022: 'فشل التحقق من رد الدفع – حاول لاحقاً.',
  v3SubmitErrMsg121000: 'النظام مشغول – حاول لاحقاً.',
  v3SubmitErrMsg120011: 'معرف المنتج خاطئ – اختر مجدداً.',
  v3SubmitErrMsg121015: 'فشل التحقق من مبلغ الدفع – قدم طلباً جديداً.',
  v3SubmitErrMsg120004: 'قناة الدفع غير مفتوحة – اختر طريقة أخرى.',
  v3SubmitErrMsg120005: 'قناة الدفع قيد الصيانة – استخدم طريقة أخرى.',
  v3SubmitErrMsg120007: 'معرف المنصة غير صالح – سجل الدخول مجدداً.',
  v3SubmitErrMsg120008: 'معاملات الطلب غير كافية – أعد الإرسال.',
  v3SubmitErrMsg120013: 'رقم طلب المطور غير صالح – قدم طلباً جديداً.',
  v3SubmitErrMsg120018: 'تم حظر الدفع بواسطة التحكم في المخاطر – اتصل بالدعم للتحقق.',
  v3SubmitErrMsg120019: 'فشل التحقق من اسم الحزمة – استخدم النسخة الرسمية.',
  v3SubmitErrMsg120021: 'فشل التحقق من معرف المنتج – اختر مجدداً.',
  v3SubmitErrMsg120023: 'خطأ في إرسال هدية التسجيل المسبق – تحقق لاحقاً.',
  v3SubmitErrMsg120026: 'الحساب غير موجود – تحقق من حالة الحساب.',
  v3SubmitErrMsg120030: 'المخزون الإجمالي غير كافٍ – اختر منتجاً آخر.',
  v3SubmitErrMsg120031: 'تجاوزت الحد الأقصى لشراء هذا المنتج – قم بالتعديل.',
  v3SubmitErrMsg120032: 'إصدار اللعبة قديم جداً – حمل أحدث إصدار.',
  v3SubmitErrMsg120080: 'دفع الوكيل مقيد بالتحكم في المخاطر – استخدم طريقة الدفع الخاصة بك.',
  v3SubmitErrMsg120081: 'دفع الوكيل تأخر بسبب التحكم في المخاطر – تحقق من النتيجة لاحقاً.',
  v3SubmitErrMsg121002: 'ذاكرة التخزين المؤقت للطلب غير صالحة – قدم طلباً جديداً.',
  v3SubmitErrMsg121003: 'تكوين الشحن غير موجود – اتصل بالدعم.',
  v3SubmitErrMsg121004: 'معاملات موسعة غير كافية – أعد الإرسال.',
  v3SubmitErrMsg121005: 'فشل كتابة ذاكرة التخزين المؤقت – حاول لاحقاً.',
  v3SubmitErrMsg121006: 'فشل قراءة ذاكرة التخزين المؤقت – حاول لاحقاً.',
  v3SubmitErrMsg121007: 'خطأ في تكوين نوع الشحن – اتصل بالدعم.',
  v3SubmitErrMsg121011: 'تم اكتشاف حقول جديدة من Apple – قم بتحديث التطبيق.',
  v3SubmitErrMsg121013: 'طلب التجديد غير موجود – اشترك مجدداً.',
  v3SubmitErrMsg121014: 'فشل فك تشفير معلمات الشحن – أعد الإرسال.',
  v3SubmitErrMsg121017: 'تم استرداد هذا الطلب – اتصل بالدعم للتأكيد.',
  v3SubmitErrMsg121018: 'انتهت صلاحية الاشتراك – اشترك مجدداً.',
  v3SubmitErrMsg121020: 'تم إلغاء الطلب – قدم طلباً جديداً.',
  v3SubmitErrMsg121021: 'خطأ في Google API – حاول لاحقاً.',
  v3SubmitErrMsg121022: 'فشل الحصول على رمز الوصول – سجل الدخول مجدداً.',
  v3SubmitErrMsg121023: 'حالة الطلب غير طبيعية – تحقق من حالة الإيداع.',
  v3SubmitErrMsg121024: 'فشل تأكيد الطلب – حاول لاحقاً.'
};
